<template>
    <div class="poster">
        <div class="title">
            <p>价格预警</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-input v-model="formInline.id" placeholder="请输入编号ID" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.agency_name" placeholder="请输入经销商名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.keyword" placeholder="请输入姓名 / 电话" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="价格上限" name="1">
                        <div slot="label">
                            <el-badge :value="up_price_warning" :hidden="up_price_warning <= 0" class="item"> 价格上限 </el-badge>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="价格下限" name="2">
                        <div slot="label">
                            <el-badge :value="down_price_warning" :hidden="down_price_warning <= 0" class="item"> 价格下限 </el-badge>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="table">
                <el-table :data="tableData" style="width: 100%" v-loading="tabload">
                    <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
                    <el-table-column prop="type" label="预警类型" align="center" width="180px">
                        <template slot-scope="scope">
                            <div class="dot">
                                <el-badge is-dot class="item" :hidden="scope.row.is_read == 1">{{ scope.row.type == 1 ? "价格上限" : "价格下限" }}</el-badge>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="agency_name" label="经销商名称" align="center" width="180px"> </el-table-column>
                    <el-table-column prop="principals_name" label="负责人名称" align="center" width="180px"> </el-table-column>
                    <el-table-column prop="principals_phone" label="负责人电话" align="center" width="180px"> </el-table-column>
                    <el-table-column prop="level" label="经销级别" align="center" width="180px">
                        <template slot-scope="scope">
                            <p>{{ scope.row.level == 1 ? "一级" : scope.row.level == 2 ? "二级" : "三级" }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="预警时间" align="center" width="180px"> </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link type="primary" @click="detail(scope.row)">详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <Detail ref="refDetail" :activeName="activeName"></Detail>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

import Detail from "@/components/Modules/PriceWarn/Detail.vue";

export default {
    components: {
        Detail,
    },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            selType: 1,
            tableData: [],
            formInline: {
                keyword: "",
                agency_name: "",
                id: "",
            },
            activeName: "1",
            type: "",
            down_price_warning: 0,
            up_price_warning: 0,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getList(1);
        this.getCount();
    },
    methods: {
        ...mapActions({
            getProductPrice: "brand/getProductPrice",
            getunread: "brand/getunread", //未读数
        }),
        getCount() {
            let params = {
                token: this.getToken,
                name: "price_protection",
            };
            this.getunread(params).then(({ data }) => {
                if (data.code == 1) {
                    this.down_price_warning = data.data.down_price_warning;
                    this.up_price_warning = data.data.up_price_warning;
                }
            });
        },
        detail(row) {
            if (row.is_read == 0) {
                row.is_read = 1;
                switch (Number(this.activeName)) {
                    case 1:
                        this.up_price_warning -= 1;
                        break;
                    case 2:
                        this.down_price_warning -= 1;
                        break;
                    default:
                        break;
                }
            }
            this.$refs.refDetail.dialogVisible = true;
            this.$refs.refDetail.getDetail(row.id, this.activeName);
        },
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                type: Number(this.activeName),
                size: this.size, //页大小
                page: tag == 1 ? 1 : this.page, //页数
                id: this.formInline.id,
                agency_name: this.formInline.agency_name,
                keyword: this.formInline.keyword,
            };
            this.getProductPrice(opt).then(({ data }) => {
                this.tabload = false;
                if (data.code == 1) {
                    this.tableData = data.data.list;
                    this.total = data.data.count ? data.data.count : 0;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        onSubmit() {
            this.getList(1);
        },
        reset() {
            this.formInline = {
                type: "0",
                data: "",
            };
            this.getList(1);
        },
        handleClick() {
            // console.log(this.activeName);
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    ::v-deep .el-tabs__item {
        text-align: center;
    }

    .title {
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
        .tabs {
            position: relative;
        }
        .btnlist {
            position: absolute;
            right: 0;
            bottom: 28px;
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
.dot {
    ::v-deep .el-badge__content.is-dot {
        left: -24px;
        top: 10px;
    }
}

.tabs {
    ::v-deep .el-badge__content.is-fixed {
        top: 20px;
        right: -10px;
    }
}
</style>